import $ from "jquery"
import { GARemoveFromCart } from "../ga/remove_from_cart"
import { GAViewCart } from "../ga/view_cart"
import eSputnik from "../eSputnik"
import { GUID, getLocalizedHomeUrl } from "../../utils"
import renderModalCart from "../react/ModalCart"
import GlobalState from "../globalState"
import { deleteProduct, getCart } from "../react/api"
import { CartItemType } from "../../types"

// window.items_in_cart used in:
// analytics

window.globalCart = new GlobalState({
  isLoading: null,
  cart: {},
  cartItems: [],
  discount: {},
})

window.getDiscountPayload = new GlobalState({
  bonus: null,
  coupon: null,
  delivery: null,
  marketing_bonus: null,
  payment: null,
})

let itemsInCart = {}

const updateBuyButton = (ids: number[]) => {
  const buyButtons = document.querySelectorAll(
    ".js_product_buy_button span, .js_fixed_product_buy span",
  )
  if (!buyButtons.length) return
  const selectorAllSizesInCart = ids.map((id) => `label[data-id="${id}"]`).join(", ")
  selectorAllSizesInCart.length &&
    document
      .querySelectorAll(selectorAllSizesInCart)
      .forEach((el) => el.setAttribute("data-cart", "true"))
  const labelsWithDataCart = document.querySelectorAll(`label[data-cart="true"]`)
  labelsWithDataCart.forEach((el) => {
    if (el instanceof HTMLElement) {
      const dataId = +el.dataset.id
      if (!ids.includes(dataId)) {
        el.removeAttribute("data-cart")
      }
    }
  })
  buyButtons.forEach((button) => {
    if (ids.includes(window.currentProduct.value.id)) {
      button.textContent = window.phrases.cart.in_basket
      button.setAttribute("data-target", "modal-cart")
      button.classList.add("modal-btn")
    } else {
      button.textContent = window.phrases.cart.buy
      button.removeAttribute("data-target")
      button.classList.remove("modal-btn")
    }
  })
}

const updateCartCounter = (itemsInCart: number) => {
  const headerCart: HTMLElement | null = document.querySelector(".header-controls__cart")

  if (headerCart) {
    headerCart.dataset.length = itemsInCart.toString()
    headerCart.classList.toggle("header__count", itemsInCart < 1)
  }
}

const syncCartUI = (response: { items: Record<string, CartItemType> }): number | null => {
  if (!response || !response.items) return null
  const itemsInCartCount = Object.keys(response.items).length

  window.productsIDs = Object.values(response.items).map((item: CartItemType) => item.id)

  updateCartCounter(itemsInCartCount)
  updateBuyButton(window.productsIDs)

  return itemsInCartCount
}

const modalCart = {
  isFetching: false,
  isRefreshing: false,
  create: () => {
    renderModalCart()
    // created = true;
  },
  open: function openCart({ response, isNewProduct, shouldOpen, isCheckoutPage }) {
    itemsInCart = { ...response.items }

    window.itemsInCart = itemsInCart
    this.create()

    GAViewCart()
    if (!isNewProduct) eSputnik.StatusCart(itemsInCart, new GUID())

    if (shouldOpen) {
      $(".modal-cart").fadeIn(300)
      $("html").addClass("overflow")
    }
  },
  call: async function getResponse(newProduct = false, open) {
    const isCheckoutPage = $(".checkout-fields").length
    if (this.isFetching) return
    this.isFetching = true
    window.globalCart.setValue((prev) => ({
      ...prev,
      isLoading: true,
    }))

    try {
      this.create()

      const response = await getCart()

      const itemsInCartCount = syncCartUI(response)
      // Matches the pre-refactor behavior: a malformed response (missing `.items`)
      // must not open the modal or fire GAViewCart/eSputnik.
      if (itemsInCartCount === null) return

      this.open({
        response,
        isNewProduct: newProduct,
        shouldOpen: open,
        isCheckoutPage,
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.isFetching = false
    }
  },
  // UZ-3688 Silent cart-state refresh (no modal open, no GAViewCart/eSputnik) for bfcache restore.
  // Uses its own `isRefreshing` flag (not `isFetching`) so a background refresh in flight
  // can never cause a real user click into call() to be silently dropped.
  refresh: async function refreshCartState() {
    if (this.isRefreshing) return
    this.isRefreshing = true

    try {
      const response = await getCart()

      syncCartUI(response)
    } catch (error) {
      console.log(error)
    } finally {
      this.isRefreshing = false
    }
  },
}

const removeFromCart = () => {
  const query = async (id: String) => {
    try {
      window.globalCart.setValue((prev: GlobalState) => ({
        ...prev,
        isLoading: true,
      }))

      const response = await deleteProduct(id)
      const { items, common, totals, general } = response

      const isCheckoutPage = document.querySelector(".checkout-fields")
      const itemsInCartCount = Object.keys(items).length
      const ids = window.productsIDs.filter((item) => item !== +id)
      updateCartCounter(itemsInCartCount)
      updateBuyButton(ids)
      if (itemsInCartCount === 0 && isCheckoutPage) {
        window.location.href = getLocalizedHomeUrl()
      }

      if (window.removeFromCart !== undefined) {
        window.removeFromCart(id)
      }
      const removedItem = Object.entries(itemsInCart).filter(
        (item) => (item[1] as any).id === id,
      )

      window.itemsInCart = { ...items }
      // Analytics. Remove from cart. remove_from_cart. removeFromCart
      GARemoveFromCart(removedItem[0][1], common)
      eSputnik.StatusCart(items, new GUID())
    } catch (error) {
      console.log(error)
    }
  }

  $(document).on("click", ".modal-cart .cart-card__remove", function removeOnClick() {
    const $this = $(this)
    const id = $this.data("id")

    query(id)

    if (window.productsIDs !== undefined) {
      const inArr = window.productsIDs.indexOf(id)

      window.productsIDs.splice(inArr, 1)
    }
  })
}

removeFromCart()

// UZ-3688 Refresh buy buttons / cart counter from server on bfcache back-navigation restore.
// Skipped on the checkout page: Form.jsx's own pageshow handler already refreshes cart state
// there (and owns the empty-cart redirect), so this avoids a duplicate network request.
window.addEventListener("pageshow", (event: PageTransitionEvent) => {
  if (event.persisted && !document.querySelector(".checkout-fields")) {
    modalCart.refresh()
  }
})

export default modalCart
